module.exports = __webpack_public_path__ + "static/media/bulle-plumes.a6dcfb0f.png";